module.exports = __webpack_public_path__ + "static/Gotham-BookItalic-80f10f243460f6ffad2e98123117c15e.ttf";